export {ARTICLE_WYSIWYG_TYPE, default as HgArticleWYSIWYGContainer} from './Article'
export {default as HgLegalWYSIWYGContainer, LEGAL_WYSIWYG_TYPE} from './Legal'
export {type HgWYSIWYGType} from './types'
